import { Account, IncomeType, ExpenseType, SalesAccount } from "../settingsApi";

export const PRICING_CATEGORIES = [
  { id: "BaseHours" },
  { id: "Supplements" },
  { id: "ShortTimeWorkingScheme" },
  { id: "MidweekHolidays" },
  { id: "SickLeave" },
  { id: "HolidaySalary" },
  { id: "HolidayBonus" },
  { id: "TaxFreeExpenses" },
  { id: "Benefits" },
  { id: "NetChanges" },
];

export const SCHEDULING_PERIOD_TYPES = [
  { id: "schc-1m", name: "OnceInMonth" },
  { id: "schc-2m", name: "TwiceInMonth" },
  { id: "schc-2w-odd", name: "TwoWeeksOddEven" },
  { id: "schc-2w-even", name: "TwoWeeksEvenOdd" },
];

export const handleAccountsData = (accounts: any) => {
  let accountsArray: Account[] = [];
  Object.keys(accounts).forEach((key: any) => {
    accountsArray.push({
      id: key,
      accountCode: key,
      name: accounts[key].toString(),
    });
  });
  return accountsArray;
};

export const handleSalesAccountsData = (accounts: any) => {
  let accountsArray: SalesAccount[] = [];
  Object.keys(accounts).forEach((key: any) => {
    accountsArray.push({
      id: key,
      ...accounts[key],
    });
  });
  return accountsArray;
};

export const handleIncomeTypesData = (incomeTypes: any) => {
  let incomeTypesArray: IncomeType[] = [];
  Object.keys(incomeTypes).forEach((key: any) => {
    incomeTypesArray.push({
      id: key,
      incomeCode: key,
      name: incomeTypes[key].toString(),
    });
  });
  return incomeTypesArray;
};

// Turn expenseTypeMappings records into objects with ids and
// assign translated names into their own fields
export const handleExpenseTypesData = (expenseTypes: any) => {
  let expenseTypesArray: any = [];
  Object.keys(expenseTypes).forEach((key: any) => {
    expenseTypesArray.push({
      ...expenseTypes[key],
      id: key,
      name: expenseTypes[key].name.fi,
      nameEN: expenseTypes[key].name.en,
      nameSV: expenseTypes[key].name.sv,
    });
  });
  return expenseTypesArray;
};

// Remove soft-deleted items and turn objects back into records
export const reduceExpenseTypes = (expenseTypes: ExpenseType[]) => {
  return expenseTypes
    .filter((item: any) => item.status !== "deleted")
    .reduce((map: any, obj: any) => {
      const nameObject = { fi: obj.name, en: obj.nameEN, sv: obj.nameSV };
      map[obj.code] = { ...obj, name: nameObject };
      return map;
    }, {});
};
